export enum TargetKinds {
  Directory = 1,
  Format,
}
